import { ROUTES } from "@/@core/constants/routes";
import { Link } from "@/components/CustomLink";
import HomeIcon from "@heroicons/react/24/solid/HomeIcon";
import React from "react";
import { useServerTranslation } from "@/app/i18n";
import NavbarHomepageBlock from "@/components/layout/header/links/homepage-block";
import { useTranslation } from "@/hooks/translationContext";

export default function NavbarLinks({site}: {site: Site.Site}) {
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { t } = useTranslation()

  const venueFilterTitle = t("text-menu-venue-filter", {
    defaultValue: "Mekanlar",
  });

  const NAVBAR_LINKS = [
    {
      href: site.setting?.routes?.generalList,
      text: venueFilterTitle,
    },
    {
      href: ROUTES.CAMPAIGNS,
      text: t("text-menu-content-campaign", {
        defaultValue: "Kampanyalar",
      }),
      isHidden: site?.setting?.disabledPages?.campaign === 1,
    },
    {
      href: ROUTES.EVENTS,
      text: t("text-menu-content-event", {
        defaultValue: "Etkinlikler",
      }),
      isHidden: site?.setting?.disabledPages?.event === 1,
    },
    {
      href: `/${site?.setting?.routes?.trainer}`,
      text: t("text-menu-user-filter", {
        defaultValue: "Çalışanlar",
      }),
      isHidden: site?.setting?.disabledPages?.trainer === 1,
    },
    {
      href: ROUTES.BLOG,
      text: t("text-menu-content-blog", {
        defaultValue: "Blog",
      }),
    },
  ];

  const filteredNavbarLinks = NAVBAR_LINKS.filter((n) => !n.isHidden);

  return (
    <NavbarHomepageBlock>
      <div className="flex gap-2 items-center">
        <Link title={venueFilterTitle} href={site.setting?.routes?.generalList}>
          <HomeIcon className="size-4 text-white" />
        </Link>

        {filteredNavbarLinks.map((link, index) => (
          <Link
            title={link.text}
            href={link.href}
            key={index}
            className="group w-auto p-2 transition-colors duration-150 hover:bg-white/10 hover:text-rose-500 rounded-2xl"
          >
          <span className="text-white group-hover:text-rose-500 duration-150 text-sm font-bold font-['DM Sans']">
            {link.text}
          </span>
          </Link>
        ))}
      </div>
    </NavbarHomepageBlock>
  );
}
